<template>
  <div class="btn" @click="clicked">
    <p
      :disabled="isBusy"
      class="action-button"
      :class="{ 'orange-gradient': !isBusy, 'wriggle': wrongQrCode }">
      <i class="fas" :class="iconClass"></i> 
      {{ buttonLabel }}
    </p>
  </div>
</template>

<script>
export default {
  props: ['label', 'isBusy', 'wrongQrCode', 'fwIcon'],
  data () {
    return {
      iconClass: 'fa-' + this.fwIcon
    }
  },
  computed: {
    buttonLabel () {
      return this.isBusy ? 'Cancel' : this.label
    }
  },
  methods: {
    clicked () {
      this.$emit('button-clicked')
    }
  }
}
</script>

<style lang="scss" scoped>
  .btn {
    z-index: 100;
    display: flex;
    -webkit-display: flex;
    width: 40%;
    max-width: 400px;
    height: 50px;
    border: none;
    border-radius: 50px;
    -webkit-border-radius: 50px;
    letter-spacing: .5px;
    font-size: 18px;
    color: white;
    font-weight: 700;
    background-color: #464A53;
    margin: 10px auto;
    transition: all .3s ease-out;
    -webkit-transition: all .3s ease-out;
    box-shadow: 0px 5px 5px 1px darkgray;

    &.wriggle {
      animation: vibrating 1s linear forwards;
      -webkit-animation: vibrating 1s linear forwards;
      color: #464A53;
    }

    p {
      display: flex;
      align-items: center;
      justify-content: space-around;
      -webkit-display: flex;
      -webkit-align-items: center;
      -webkit-justify-content: space-around;
      margin: 0px;
      padding: 10px;
      width: 100%;
      border-radius: 50px;
      -webkit-border-radius: 50px;
    }
  }

  @keyframes rotating {
    from {
      transform: translate(-50%, -50%) rotate(0deg);
      -webkit-transform: translate(-50%, -50%) rotate(0deg);
    }
    to {
      transform: translate(-50%, -50%) rotate(360deg);
      -webkit-transform: translate(-50%, -50%) rotate(360deg);
    }
  }

  @keyframes vibrating {
    0%   { margin-left: 0px; }
    10%  { margin-left: -20px; }
    20%  { margin-left: 20px; }
    30%  { margin-left: -20px; }
    40%  { margin-left: 20px; }
    50%  { margin-left: -20px; }
    60%  { margin-left: 20px; }
    70%  { margin-left: -20px; }
    80%  { margin-left: 20px; }
    90%  { margin-left: -20px; }
    100% { margin-left: 0px; }
  }

  @media screen and (max-width: 320px) {
    .btn {
      height: 40px;
      font-size: 14px;

      i {
        font-size: 25px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/buttons/HomeButton.vue